import { Components, Theme } from '@mui/material';

export const MuiTabs = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderBottom: `1px solid ${theme.palette.neutral.outlineVariant}`,
    }),
  },
} as Components<Theme>['MuiTabs'];

export const MuiTab = {
  styleOverrides: {
    root: ({ theme, ownerState }) => {
      const tabStyles = {
        ...theme.typography.body2Bold,
        minHeight: 48,
        color: theme.palette.neutral.onSurfaceVariant,
        '&.error': {
          color: theme.palette.error.main
        },
        '&.MuiTab-root': {
          color: theme.palette.neutral.onSurfaceVariant,
          '&:hover': {
            backgroundColor: theme.palette.neutral.containerLowest,
          },
        },
        '&.Mui-selected': {
          color: theme.palette.primary.main,
          backgroundColor: 'transparent',
          '&.error': {
            color: theme.palette.error.main
          },
        },
        ...theme.createStateLayer('transparent')
      };

      const minTabWidth = {
        minWidth: 0
      };

      if (ownerState.icon && !ownerState.label) {
        return { ...tabStyles, ...minTabWidth };
      } else {
        return tabStyles;
      }
    },
  },
} as Components<Theme>['MuiTab'];